import * as React from "react";
import { joinClasses } from "../../../utils/Filters";
import { asThemeConsumer } from "../../../theme/Theme";
/**
 *
 * @param props
 */
export var NavbarComp = function (_a) {
    var children = _a.children, className = _a.className;
    var clazzName = joinClasses("scl-o-navbar", className);
    return (React.createElement("div", { className: clazzName },
        React.createElement("div", { className: "scl-o-navbar__content" }, children)));
};
/**
 *
 */
export var Navbar = asThemeConsumer(NavbarComp);
